<template>
  <div>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">LIST OF GGC LOANS</h4></v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap class="align-center mx-2 mt-4">
        <v-flex xs12 md4>
          <v-select
            class="mx-2"
            v-model="status"
            :items="['Unpaid','Paid']"
            label="Status"
            required
            :rules="rules.combobox_rule"
            dense
            outlined
            @change="search_data"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="align-center mx-2">
        <v-flex xs12 md4>
          <v-select
            class="mx-2"
            v-model="type_of_loan"
            :items="position==='AMD'?['Tie-Up','Damayan']:['All','Tie-Up','Damayan','Business']"
            label="Loan Type"
            required
            :rules="rules.combobox_rule"
            dense
            outlined
            @change="search_data"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-data-table dense
                    class="mt-3"
                    :headers="headers"
                    :items="data"
                    disable-pagination
                    hide-default-footer
                    :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <h2>Print|
              <v-icon class="mr-2" color="success" @click="print_data"
                      v-if="!printt">
                {{ icons.mdiPrinter }}
              </v-icon>
              <v-progress-circular :size="25" :width="5" color="success" indeterminate
                                   v-if="printt"></v-progress-circular>
            </h2>
            <v-spacer></v-spacer>

            <v-text-field
              class="mx-2"
              :append-icon="icons.mdiAccountSearchOutline"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td>
              {{
                data
                  .map(function (x) {
                    return x.id
                  })
                  .indexOf(item.id) + 1
              }}
            </td>
            <td>
              {{ item.date }}
            </td>
            <td>
              {{ item.name }}
            </td>
            <td>
              {{ item.collateral }}
            </td>
            <td>
              {{ formatPrice(item.loan_amount) }}
            </td>
            <td>
              {{ item.terms + ' months' }}
            </td>
            <td>
              {{ item.interest + ' %' }}
            </td>
            <td>
              {{ formatPrice(item.total_interest) }}
            </td>
            <td>
              {{ formatPrice(item.total_loan) }}
            </td>
            <td>
              {{ formatPrice(get_balance(item)) }}
            </td>
            <td class="text-center">
              <v-icon
                class="mr-2"
                color="warning"
                @click="print_soa(item)"
              >
                {{ icons.mdiAccountClock }}
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <snack-bar-dialog :snackbar_flag="this.snackbar" :color="this.snackbar_color"
                      :snackbar_text="this.snackbar_text"/>
  </div>
</template>

<script>
import {
  mdiCheck, mdiClose, mdiPlusBox
  , mdiPencil
  , mdiAccountSearchOutline
  , mdiAccountClock,mdiPrinter
} from '@mdi/js'
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'
import {P} from 'caniuse-lite/data/agents'

const initialState = () => {
  return {
    search: '',
    status: '',
    type_of_loan: '',
    printt:false,
    data: [],
    headers: [
      {text: 'No.', value: 'id', sortable: false},
      {text: 'Date', value: 'date', sortable: false},
      {text: 'Name', value: 'name', sortable: false},
      {text: 'Collateral', value: 'date', sortable: false},
      {text: 'Loan Amount', value: 'loan_amount', sortable: false},
      {text: 'Terms', value: 'terms', sortable: false},
      {text: 'Interest (%)', value: 'interest', sortable: false},
      {text: 'Interest', value: 'total_interest', sortable: false},
      {text: 'Total Loan', value: 'total_loan', sortable: false},
      {text: 'Loan Balance', value: 'total_loan', sortable: false},
      {text: 'SOA', value: 'total_loan', sortable: false},
    ],
  }
}
export default {
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiCheck,
        mdiClose,
        mdiPlusBox,
        mdiPencil,
        mdiAccountSearchOutline,
        mdiAccountClock,
        mdiPrinter,
      },
    }
  },
  data() {
    return initialState()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('authentication', ['address', 'contact','position']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo', 'trea']),
    ...mapGetters('system_data', [
      'snackbar',
      'snackbar_color',
      'snackbar_text',
      'company_logo',
      'damayan',
      'chapel',
      'factory',
      'coop',
      'printing',
      'accounting',
      'admin',
      'amd',
      'audit',
      'book',
      'creative',
      'ecut',
      'hr',
      'it',
      'prot',
      'trea',
    ]),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('ggc_loans', ['list_of_ggc_loans']),
    search_data() {
      this.list_of_ggc_loans({
        status: this.status,
        position: this.position,
        type_of_loan: this.type_of_loan,
      })
        .then(response => {
          this.data = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    date_format(value) {
      return moment(value)
    },
    get_balance(value) {
      var paid = 0;
      var penalty = 0;
      value.payment_paid.forEach(function (item) {
        paid +=parseFloat(item.amount_pay)
        penalty +=parseFloat(item.penalty)
      })
      return (parseFloat(value.total_loan)+parseFloat(penalty)) - parseFloat(paid)
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },print_soa(data) {
      var accounts_array = []
      accounts_array.push(
        [
          {text: 'Due Date', alignment: 'left', style: 'label'},
          {text: 'OR date', alignment: 'left', style: 'label'},
          {text: 'OR #', alignment: 'left', style: 'label'},
          {text: 'Principal', alignment: 'left', style: 'label'},
          {text: 'Interest', alignment: 'left', style: 'label'},
          {text: 'Penalty', alignment: 'left', style: 'label'},
          {text: 'Amount Paid', alignment: 'left', style: 'label'},
          {text: 'Outstanding Balance', alignment: 'left', style: 'label'},
        ]
      )
      var total_bal = parseFloat(data.total_loan)
      accounts_array.push(
        [
          {text: data.date, alignment: 'left'},
          {text: '', alignment: 'left'},
          {text: '', alignment: 'left'},
          {text: this.formatPrice(0), alignment: 'left'},
          {text: this.formatPrice(0), alignment: 'left'},
          {text: this.formatPrice(0), alignment: 'left'},
          {text: this.formatPrice(0), alignment: 'left'},
          {text: this.formatPrice(total_bal), alignment: 'left'},
        ]
      )

      data.payment.forEach(function (item) {
        var premium = parseFloat(item.amount_pay)
        total_bal += parseFloat(item.penalty)
        total_bal -= premium
        if (total_bal < 1) {
          total_bal = 0
        }
        accounts_array.push(
          [
            {text: item.due_date, alignment: 'left'},
            {text: item.or_date, alignment: 'left'},
            {text: item.or_no, alignment: 'left'},
            {
              text: (item.amount / 1).toFixed(2).replace(',', '.').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left'
            },
            {
              text: (item.interest / 1).toFixed(2).replace(',', '.').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left'
            },
            {
              text: (item.penalty / 1).toFixed(2).replace(',', '.').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left'
            },
            {
              text: ((item.deposit_slip_id === null ? 0 : premium) / 1).toFixed(2).replace(',', '.').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left'
            },
            {
              text: (total_bal / 1).toFixed(2).replace(',', '.').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left'
            },
          ]
        )
      })

      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var docDefinition = {
        pageSize: 'LETTER',
        content: [
          {
            columns: [
              {image: this.company_logo, width: 54, height: 54, style: 'logo'},
              {
                stack: [
                  'GOODLIFE GROUP OF COMPANIES',
                  {text: this.address, style: 'subheader2'},
                  {text: this.contact, style: 'subheader2'},
                  {
                    text: 'Printed as of: ' + moment().format('MMMM D, YYYY'),
                    style: 'printed_label',
                  },
                ],
                style: 'header'
              },
              {
                image: this.trea,
                width: 60,
                height: 54,
                style: 'logo',
              },
            ]
          },
          {text: 'LOAN STATEMENT OF ACCOUNT', style: 'title'},
          '================================================================================',
          ' ',
          {
            columns: [
              {
                text: 'Date Accomplished: ' + data.date,
                style: 'main_info'
              },
              {
                text: 'ID#: ' + data.id,
                style: 'main_info'
              },
            ]
          },
          '_________________________________________________________________________________________________',
          'MEMBERS PERSONAL INFORMATION',
          ' ',
          {
            columns: [
              {
                text: 'Applicant Name: ' + data.name,
                style: 'main_info'
              },
              {
                text: 'Contact #: ' + data.contact_no,
                style: 'main_info'
              },
            ]
          },
          {
            columns: [
              {
                text: 'Present Address: ' + data.address,
                style: 'main_info'
              },
            ]
          },
          '_________________________________________________________________________________________________',
          'CO MAKER INFORMATION',
          ' ',
          {
            columns: [
              {text: 'CO - MAKER NAME', style: 'main_info'},
            ]
          },
          {
            columns: [
              {
                text: data.co_maker,
                style: 'main_info'
              },
            ]
          },
          '_________________________________________________________________________________________________',
          'LOAN DATA',
          ' ',
          {
            columns: [
              {text: data.terms + ' month/s', style: 'main_info'},
              {text: '|', style: 'main_info'},
              {
                text: this.formatPrice(data.loan_amount) + '     +',
                style: 'main_info'
              },
              {
                text: this.formatPrice(data.total_interest) + '     +',
                style: 'main_info'
              },
              {text: this.formatPrice(data.total_loan), style: 'main_info'},
            ]
          },
          {
            columns: [
              {text: 'Terms', style: 'sub_info'},
              {text: '|', style: 'main_info'},
              {text: 'Loan Amount', style: 'sub_info'},
              {text: 'Interest', style: 'sub_info'},
              {text: 'Total', style: 'sub_info'},
            ]
          },
          '================================================================================',
          ' ',
          {
            style: 'tableExample',
            color: '#444',
            table: {
              widths: [60, 60, 60, 60, 60, 60, 60, 60],
              body: accounts_array,
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex === 0) ? '#CCCCCC' : null;
              },
            },
          },

        ],
        footer: {
          columns: [
            {
              text: 'Generated with GGC System',
              alignment: 'center',
              style: 'tableExample'
            }
          ]
        },
        styles: {
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 20]//[left, top, right, bottom]
          },
          subheader: {
            fontSize: 12
          },
          subheader2: {
            fontSize: 8,
          },
          title: {
            fontSize: 15,
            alignment: 'center',
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0]//[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 4, 0, 0]//[left, top, right, bottom]
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
          },
          sub_info: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
          },
          tableExample: {
            fontSize: 9,
          },
        },
      }
      pdfMake.createPdf(docDefinition).open();

      this.saving = false
    },
    async print_data() {
      this.printt = true
      var imgData = this.company_logo

      var payments_array = []
      var widths = []
      var damayan_ = this.damayan
      var chapel_ = this.chapel
      var factory_ = this.factory
      var coop_ = this.coop
      var printing_ = this.printing
      var info_array = []

      widths = [20,40, 120, 120, 50, 50, 30,50,50,50,]
      payments_array.push([
        {text: 'No.', alignment: 'left', style: 'main_info'},
        {text: 'Date', alignment: 'left', style: 'main_info'},
        {text: 'Name', alignment: 'left', style: 'main_info'},
        {text: 'Collateral', alignment: 'left', style: 'main_info'},
        {text: 'Loan Amount', alignment: 'left', style: 'main_info'},
        {text: 'Terms', alignment: 'left', style: 'main_info'},
        {text: '%', alignment: 'left', style: 'main_info'},
        {text: 'Interest', alignment: 'left', style: 'main_info'},
        {text: 'Total Loan', alignment: 'left', style: 'main_info'},
        {text: 'Balance', alignment: 'left', style: 'main_info'},
      ])
      var total_amm = 0
      var total_intt = 0
      var total_loan = 0
      var total_balance = 0
      this.data.forEach(function (item, index, payment) {
        total_amm += parseFloat(item.loan_amount)
        total_intt += parseFloat(item.total_interest)
        total_loan += parseFloat(item.total_loan)
        var paid = 0;
        var penalty = 0;
        item.payment_paid.forEach(function (item) {
          paid +=parseFloat(item.amount_pay)
          penalty +=parseFloat(item.penalty)
        })
        var bal= (parseFloat(item.total_loan)+parseFloat(penalty)) - parseFloat(paid)
        total_balance += bal
        payments_array.push([
          {
            text: index+1,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.date,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.name,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.collateral,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text:
              item.loan_amount === 0
                ? ''
                : (item.loan_amount / 1)
                  .toFixed(2)
                  .replace(',', '.')
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.terms + ' months',
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.interest + ' %',
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text:
              item.total_interest === 0
                ? ''
                : (item.total_interest / 1)
                  .toFixed(2)
                  .replace(',', '.')
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text:
              item.total_loan === 0
                ? ''
                : (item.total_loan / 1)
                  .toFixed(2)
                  .replace(',', '.')
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text:
              bal === 0
                ? ''
                : (bal/ 1)
                  .toFixed(2)
                  .replace(',', '.')
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2',
          },

        ])
        if (Object.is(payment.length - 1, index)) {
          // execute last item logic
          payments_array.push([
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: 'TOTAL',
              alignment: 'left',
              style: 'tableExample2',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: 'TOTAL INTEREST',
              alignment: 'left',
              style: 'tableExample2',
            },
            {
              text: 'TOTAL LOAN',
              alignment: 'left',
              style: 'tableExample2',
            },
            {
              text: 'TOTAL BALANCE',
              alignment: 'left',
              style: 'tableExample2',
            },
          ])
          payments_array.push([
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: 'TOTAL',
              alignment: 'right',
              style: 'tableExample2',
            },
            {
              text: (total_amm / 1)
                .toFixed(2)
                .replace(',', '.')
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left',
              style: 'tableExample2',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: (total_intt / 1)
                .toFixed(2)
                .replace(',', '.')
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left',
              style: 'tableExample2',
            },
            {
              text: (total_loan / 1)
                .toFixed(2)
                .replace(',', '.')
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left',
              style: 'tableExample2',
            },
            {
              text: (total_balance / 1)
                .toFixed(2)
                .replace(',', '.')
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left',
              style: 'tableExample2',
            },
          ])
        }
      })

      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs
      }
      var docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'landscape',
        content: [
          {
            columns: [
              {image: imgData, width: 60, height: 54, style: 'logo'},
              {
                stack: [
                  'GOODLIFE GROUP OF COMPANIES',
                  {text: this.address, style: 'subheader2'},
                  {
                    text: this.contact,
                    style: 'subheader2',
                  },
                  {
                    text: 'Printed as of: ' + moment().format('MMMM D, YYYY'),
                    style: 'printed_label',
                  },
                ],
                style: 'header',
              },
              {
                image:
                  this.position === 'ADMIN'
                    ? this.admin
                    : this.position === 'TREASURY'
                      ? this.trea
                      : this.position === 'ACCOUNTING'
                        ? this.accounting
                        : this.position === 'AMD'
                          ? this.amd
                          : this.position === 'PROPERTY CUSTODIAN'
                            ? this.prot
                            : this.position === 'HUMAN RESOURCE'
                              ? this.hr
                              : this.position === 'BOOKKEEPING'
                                ? this.book
                                : this.position === 'CMD'
                                  ? this.accounting
                                  : imgData,
                width: 60,
                height: 54,
                style: 'logo',
              },
            ],
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: 'LIST OF LOANS',
                    style: {
                      fontSize: 16,
                      alignment: 'center',
                      bold: true,
                    },
                  },
                ],
              },
            ],
          },
          '_________________________________________________________________________________________________________________________',
          {
            columns: [{text: ' '}],
          },
          {
            columns: [{text: 'Loan Type: ' + this.type_of_loan}],
          },
          {
            stack: info_array,
          },
          {
            columns: [{text: ' '}],
          },
          {
            table: {
              widths: widths,
              body: payments_array,
              style: {fontSize: 1},
            },
            layout: {
              fillColor: function (rowIndex) {
                return rowIndex === 0 ? '#CCCCCC' : null
              },
            },
          },
          {
            stack: [
              {
                columns: [{text: ' '}],
              },
              {
                columns: [{text: ' '}],
              },
              {
                columns: [
                  {
                    text: 'PROCESSED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: 'DEPARTMENT RECEIVER',
                    style: 'main_data_2',
                  },
                  {
                    text: 'RECEIVED BY',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.name,
                    style: 'main_data_2',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: '',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.position,
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: ' ',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'VERIFIED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: 'AUDITED BY',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '_________________________________________',
                  },
                  {
                    text: '_________________________________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'BOARD OF DIRECTOR',
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name (TREASURY)',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: ' ',
                  },
                  {
                    text: ' ',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'APPROVED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: '_________________________________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: ' ',
                  },
                  {
                    text: 'Signature Over Printed Name (ACCOUNTING)',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: ' ',
                  },
                  {
                    text: ' ',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'ALBERT M. HILARIO',
                    style: 'main_data_2',
                  },
                  {
                    text: '_________________________________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'EVP HEAD FINANCE',
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name (EXECUTIVE)',
                    style: 'main_data_2',
                  },
                ],
              },
            ],
          },
        ],
        footer: function (currentPage, pageCount) {
          return {
            margin: 10,
            columns: [
              {
                text: 'Page ' + currentPage.toString() + ' of ' + pageCount,
                fontSize: 9,
                alignment: 'left',
              },
              {image: damayan_, width: 34, height: 20, style: 'logo'},
              {image: chapel_, width: 34, height: 20, style: 'logo'},
              {image: factory_, width: 34, height: 20, style: 'logo'},
              {image: coop_, width: 34, height: 20, style: 'logo'},
              {image: printing_, width: 34, height: 20, style: 'logo'},
            ],
          }
        },
        styles: {
          tableExample: {
            fontSize: 9,
          },
          tableExample2: {
            fontSize: 7,
          },
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 5], //[left, top, right, bottom]
          },
          subheader: {
            fontSize: 11,
          },
          subheader2: {
            fontSize: 10,
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          main_data: {
            margin: [0, 2, 0, 2],
            fontSize: 9,
            bold: true,
            alignment: 'left',
          },
          main_data_2: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
            bold: true,
            alignment: 'left',
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
            alignment: 'left',
          },
        },
      }
      pdfMake.createPdf(docDefinition).open()
      this.printt = false
    },
  },
}
</script>
